
<template>


    <div>


<v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
<v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>



  <EditarProveedorDialog ref="editarProveedorDialog" @actualizado="despuesDeActualizar"></EditarProveedorDialog>


<!-- <h3>{{proveedor}}</h3>  -->

    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Registro de Proveedors</v-toolbar-title>
      </v-toolbar>
      <v-tabs v-model="tab">
       
       <v-tab href="#one">
          <v-icon left>mdi-account</v-icon>
          Registro
        </v-tab>
        
        <v-tab href="#two" >
          <v-icon left>mdi-dns</v-icon>
          Listado
        </v-tab>
    </v-tabs>
         <v-tabs-items :value="tab"> 
          <!-- <div :value="tab"> -->
        <v-tab-item value="one">
          <v-card flat>
            <v-card-text>
               <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
   
   
    <v-text-field
           v-model="proveedor.nombre"
           label="Nombre"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
    <v-text-field
           v-model="proveedor.apellido"
           label="Apellido"
      
         ></v-text-field>
   
   
    <v-text-field
           v-model="proveedor.direccion"
           label="Direccion"
          
         ></v-text-field>
   
   
    <v-text-field
           v-model="proveedor.ci"
           label="Ci"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
    <v-text-field
           v-model="proveedor.telefono"
           label="Telefono"
         
         ></v-text-field>
   
   
    <v-text-field
           v-model="proveedor.celular"
           label="Celular"
       
         ></v-text-field>
   
   
    <v-text-field
           v-model="proveedor.email"
           label="Email"
       
         ></v-text-field>
   
   
    <v-text-field
           v-model="proveedor.estado"
           label="Estado"
          
         ></v-text-field>
   
   
    <v-text-field
           v-model="proveedor.representante"
           label="Representante"
          
         ></v-text-field>
   
   
    <v-text-field
           v-model="proveedor.ruc"
           label="Ruc"
          
         ></v-text-field>
   
   
    <v-text-field
           v-model="proveedor.obs"
           label="Obs"
           
         ></v-text-field>
   
   
   

 <v-row no-gutters>
      
      <v-col>
      </v-col>

      <v-col order="last">
        
      </v-col>
     
    </v-row>


      
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrar"
      >
        Registrar
      </v-btn>

      <v-btn
        color="error"
        class="mr-4"
        @click="reset();"
      >
        Cancelar
      </v-btn>
  
    </v-form> 
            </v-card-text>


           <v-card-text>

            <v-alert
   
      colored-border
      type="info"
      elevation="2"
      
    >
      El presente registro es responsable de almacenar información sobre el Proveedor.<br>
      
    </v-alert>

          </v-card-text>




          </v-card>
        </v-tab-item>

   <!--  fin item 1-->
<v-tab-item value="two">
          <v-card flat>
            <v-card-text>

<v-text-field
            v-model="buscador" 
            placeholder="Ejemplo: Juan Perez"
            outlined
           
          >
          <template v-slot:label>
          <v-icon style="vertical-align: middle">
            mdi-magnify
          </v-icon>
          Busqueda por nombre de Proveedor
        </template>
          
          
          </v-text-field>



             
 <v-simple-table fixed-header>
    <template v-slot:default>


      <thead class="thead-dark">
        <tr>    
			
		<th scope="col">Id</th>
		<th scope="col">Nombre</th>
		<th scope="col">Apellido</th>
		<!-- <th scope="col">Direccion</th> -->
		<th scope="col">Ci</th>
		<!-- <th scope="col">Telefono</th> -->
		<th scope="col">Celular</th>
		<th scope="col">Email</th>
		<!-- <th scope="col">Estado</th> -->
		<!-- <th scope="col">Representante</th> -->
		<th scope="col">Ruc</th>
		<!-- <th scope="col">Obs</th> -->
		        <th scope="col">Editar</th>
		          <th scope="col">Eliminar</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="proveedor in proveedorsBuscados" :key="proveedor.id">       
<td>{{proveedor.id}}</td>


<td>{{proveedor.nombre}}</td>


<td>{{proveedor.apellido}}</td>


<!-- <td>{{proveedor.direccion}}</td> -->


<td>{{proveedor.ci}}</td>


<!-- <td>{{proveedor.telefono}}</td> -->


<td>{{proveedor.celular}}</td>


<td>{{proveedor.email}}</td>


<!-- <td>{{proveedor.estado}}</td> -->


<!-- <td>{{proveedor.representante}}</td> -->


<td>{{proveedor.ruc}}</td>


<!-- <td>{{proveedor.obs}}</td> -->



          <td>
              <!-- <button @click="editarProveedor(proveedor)" class="btn"><v-icon left>mdi-pencil</v-icon></button> -->
               <v-btn color="primary" @click="openEditarProveedorDialog(proveedor)">
      <v-icon left>mdi-pencil</v-icon> Editar
    </v-btn>
            </td>
            <td>
              <button @click="eliminarProveedor(proveedor)" class="btn"><v-icon left>mdi-delete-forever</v-icon></button>
            </td>
     
 </tr>
      </tbody>

    
    </template>
  </v-simple-table>

            </v-card-text>
          </v-card>
        </v-tab-item>

        <!--  fin item 2-->
     

      </v-tabs-items> 

          <!-- </div> -->
    </v-card>

  </div>
</template>


<script>


import proveedorService from "@/services/tienda/proveedorService.js";


import axios from 'axios'
import EditarProveedorDialog from "@/components/tienda/proveedor/EditarProveedorDialog.vue";




export default {

     name: 'Proveedor',
    components: { EditarProveedorDialog },

  computed: {
    tab: {
      set (tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get () {
        return this.$route.query.tab
      }
    }
  },
    data: vm => ({



      mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: 5000,
      },

      proveedorSeleccionado: {},
    valid: true,
    tab:"",
    buscador:'',
showPass: false,
  proveedors: [],
        proveedor:{

id:'',
nombre:'',
apellido:'',
direccion:'',
ci:'',
telefono:'',
celular:'',
email:'',
estado:'',
representante:'',
ruc:'',
obs:'',

          
        },














        rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres'
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],
        
    
  }),
  created(){

       }
  ,mounted(){


     this.proveedor.empresa_id="1";
     this.proveedor.estado="activo";

      this.listarProveedors();
    
      this.tab="two";

   
    },

  methods: {

    despuesDeActualizar(){

 let mensajeText = 'Actualizado correctamente...';


        this.mensaje.text=mensajeText;

        this.mensaje.color="success";
 this.mensaje.colorBtn="green darken-1";

 this.mensaje.snackbar="true";

 this.listarProveedors();


    },

openEditarProveedorDialog(proveedor) {
  this.proveedorSeleccionado = { ...proveedor }

  
      this.$refs.editarProveedorDialog.openDialog(this.proveedorSeleccionado)
   

},

   





    listarProveedors() {
      proveedorService
        .listarProveedors()
        .then((resposta) => {
      //    console.log(resposta.data);
          this.proveedors = resposta.data;
        })
  
  },
    registrar(){
    if (this.$refs.form.validate()) {
   
         // if(this.proveedor.id===""||this.proveedor.id===null){
      //Eliminar para que funcione el auto incrementable
       // delete this.proveedor.id;
       //   }

        console.log(this.proveedor);

   

          proveedorService.save(this.proveedor,this.config).then(resposta=>{
           this.limpiar();
             
              let mensajeText = 'Registro exitoso';
          this.mensaje.text=mensajeText;
           this.mensaje.color="success";
 this.mensaje.colorBtn="green darken-1";
          this.mensaje.snackbar="true";

              this.listarProveedors();
               this.selectedTab="second";
          }).catch((errors) =>{

          let mensajeError = 'Ha ocurrido un error:\n';

  // Recorremos el array de errores del backend
  if (errors.response && errors.response.data && errors.response.data.errors) {
    errors.response.data.errors.forEach((err, index) => {
      mensajeError += `${index + 1}. ${err}\n`;
    });
  } else {
    mensajeError += 'Error desconocido';
  }

  // Asignamos al snackbar
  this.mensaje.text = mensajeError;
  this.mensaje.snackbar = true; // debe ser boolean
  this.mensaje.color = "error"; // fondo rojo
  this.mensaje.colorBtn = "red darken-2"; // color de botón contraste


  })

      }
    },
    editarProveedor(proveedor){

    //  console.log('Editar Proveedor');
      
     //
     // console.log(this.proveedor);


     this.proveedor.id=proveedor.id;
     this.proveedor.id=proveedor.id;
     this.proveedor.nombre=proveedor.nombre;
     this.proveedor.apellido=proveedor.apellido;
     this.proveedor.direccion=proveedor.direccion;
     this.proveedor.ci=proveedor.ci;
     this.proveedor.telefono=proveedor.telefono;
     this.proveedor.celular=proveedor.celular;
     this.proveedor.email=proveedor.email;
     this.proveedor.estado=proveedor.estado;
     this.proveedor.representante=proveedor.representante;
     this.proveedor.ruc=proveedor.ruc;
     this.proveedor.obs=proveedor.obs;
     

      this.tab="one";
  
       console.log(proveedor);

    },
    eliminarProveedor(proveedor){

        if(confirm('Desea remover al proveedor')){


         



        
        proveedorService.delete(proveedor).then(resposta=>{

           let mensajeText = 'Registro eliminado correctamente';
          this.mensaje.text=mensajeText;
           this.mensaje.color="success";
 this.mensaje.colorBtn="green darken-1";
          this.mensaje.snackbar="true";



          this.listarProveedors();
          this.errors=[]
          this.limpiar();

        }).catch(e=>{

          this.errors =e.response.data.errors

        })

        }


        


    },
    limpiar(){

     
		this.proveedor={
				id:'',
				id:0,
				nombre:'',
				apellido:'',
				direccion:'',
				ci:'',
				telefono:'',
				celular:'',
				email:'',
				estado:'',
				representante:'',
				ruc:'',
				obs:'',
	}

        
    },
		
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  },

    watch: {
      date (val) {
        
		
       
      },
    },
  computed:{
    


    	
    proveedorsBuscados() {
          return this.proveedors.filter(proveedor => {
            return proveedor.nombre.toLowerCase().includes(this.buscador.toLowerCase());
          });
    
      }
    	
    
    
      
    
  
  },
};
</script>




